<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data () {
      return {
        section: 'Head'
      }
    },
    methods: {
      logout () {
        this.$store.commit('SET_USER', null)
        this.$store.commit('SET_TOKEN', null)

        if (window.localStorage) {
          window.localStorage.setItem('user', null)
          window.localStorage.setItem('token', null)
        }

        this.$router.push('/login')
      }
    }
  }
</script>

<style>

.loadingContainer{
  text-align: center;
  align-items: center;
}

.loading{
  color: #919191;
}

.statusButton{
  width: 7em;
  text-transform: uppercase;
}

.fa-circle-o-notch{
    color:#039BE5;
}

.brand{
  color: #1abc9c;
}

</style>



// WEBPACK FOOTER //
// App.vue?75d66ad8